import React from 'react';

import Image from 'next/image';

import { TLocationFlagIconProps } from '../Header.types';
import { HeaderLanguageModalButton } from './HeaderLanguageSwitch.style';

type NextImageLayout = 'fill' | 'fixed' | 'intrinsic' | 'responsive'; // next does not expose this
type ObjectFit = JSX.IntrinsicElements['img']['style']['objectFit'];

export const HeaderLanguageSwitch = ({
  locationFlagIcon,
  openLanguageModal,
  locationIconWidthOverride,
  locationIconHeightOverride,
}: TLocationFlagIconProps) => {
  const imageSizeProps =
    locationIconWidthOverride && locationIconHeightOverride
      ? {
          width: locationIconWidthOverride,
          height: locationIconHeightOverride,
        }
      : {
          layout: 'fill' as NextImageLayout,
          objectFit: 'contain' as ObjectFit,
        };
  return (
    <HeaderLanguageModalButton onClick={openLanguageModal}>
      <Image src={locationFlagIcon.filename} alt={locationFlagIcon.alt} {...imageSizeProps} />
    </HeaderLanguageModalButton>
  );
};
